import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureFlagItem } from '@/backoffice/features/tenants/components/feature-flags/feature-flag-item';
import { TFeatureFlagsFormProps } from '@/backoffice/features/tenants/components/feature-flags/feature-flags.types';
import { Submit } from '@/shared/components/ui/form/components/submit/submit';
import { FormContent } from '@/shared/components/ui/form/form-content';
import { FormContainer } from '@/shared/components/ui/form/form.styled';

export const FeatureFlagsForm: React.FC<TFeatureFlagsFormProps> = ({
  flags,
  handleClose,
}) => {
  const { t } = useTranslation();

  return (
    <FormContainer justifyContent="space-between">
      <FormContent overflow="auto">
        {flags.length === 0 ? (
          <Typography variant="p5" color="textSecondary">
            {t('backoffice:feature_flags.empty')}
          </Typography>
        ) : (
          flags.map((flag, index) => (
            <FeatureFlagItem
              key={flag.featureName}
              index={index}
              title={flag.featureName}
              description={flag.description || undefined}
            />
          ))
        )}
      </FormContent>
      <Submit
        onClose={handleClose}
        submitButtonLabel={t('common:save_changes')}
        formHasToBeDirty
      />
    </FormContainer>
  );
};
